<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '年审费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="130px"
      >
        <section slot="car" slot-scope="prop">
          <ChooseCar
            :isRadio="true"
            v-model="prop.form.car"
            :otherSearchData="{
              orgId,
              isCheckAuthVehicle: 1,
            }"
            @change="handleChange"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  props: {
    orgId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '年审类型',
            value: 'certificatesInsuranceType',
            type: 'select',
            placeholder: '请选择年审类型',
            options: [
              {
                label: '行驶证',
                value: 1,
              },
              {
                label: '营运证',
                value: 2,
              },
            ],
          },
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '牌照类型',
            value: 'licenceTypeName',
            type: 'input',
            disabled: true,
          },
          {
            label: '年审日期',
            value: 'insuranceStartDate',
            placeholder: '请选择年审日期',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '截止有效日期',
            value: 'insuranceEndDate',
            placeholder: '请选择截止有效日期',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '年审费用',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入年审费用',
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          certificatesInsuranceType: [ // 年审类型
            { required: true, message: '请选择年审类型', trigger: 'blur' },
          ],
          insuranceStartDate: [ // 年审日期
            { required: true, message: '请选择年审日期', trigger: 'blur' },
          ],
          insuranceEndDate: [ // 截止有效日期
            { required: true, message: '请选择截止有效日期', trigger: 'blur' },
          ],
          payAmt: [ // 年审费用
            { required: true, message: '请输入年审费用', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };

          this.$refs.customForm.setVal(item);
          this.handleChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    handleChange () {
      const carInfo = this.$refs.customForm.getVal('car');
      const licenceTypeName = carInfo.licenceTypeName || ' ';
      this.$refs.customForm.setVal('licenceTypeName', licenceTypeName);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      // 年审类型
      switch (String(form.certificatesInsuranceType)) {
        case '1':
          form.certificatesInsuranceTypeName = '行驶证';
          break;
        case '2':
          form.certificatesInsuranceTypeName = '营运证';
          break;
        default:
          form.certificatesInsuranceTypeName = '--';
          break;
      }
      // 年审日期
      form.insuranceStartDate = this.formatDate(form.insuranceStartDate);
      // 截止有效日期
      form.insuranceEndDate = this.formatDate(form.insuranceEndDate);
      form.busiType = 1;
      form.ureaType = 1;
      delete form.car;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
